import { makeAutoObservable } from 'mobx'
import { post } from 'jquery'

export class Participant {
  /** @type {string} */
  id
  /** @type {string} */
  name
  /** @type {string|null} */
  position
  /** @type {string|null} */
  email
  /** @type {boolean} */
  _hasNewsletterDiscount
  /** @type {number} */
  price
  /** @type {ObservableMap} */
  discounts = new Map()

  newsletter = false

  vat
  /**
   * @param {string} id
   */
  constructor(id) {
    makeAutoObservable(this)
    this.id = id
  }

  get hasNewsletterDiscount() {
    return this.newsletter
  }

  isCheckingNewsletter = false
  async checkNewsletterStatus(eventGroup_id) {
    if (!/\S+@\S+\.\S+/.test(this.email)) {
      return
    }
    this.isCheckingNewsletter = true
    const res = await post(window.main_theme_objects.ajax_url, {
      action: 'is_subscribed_to_newsletter',
      event_id: eventGroup_id,
      email: this.email,
      name: this.name,
      position: this.position
    })
    this._hasNewsletterDiscount = res.has_discount
    this.isCheckingNewsletter = false
  }

  get newsletterDiscount() {
    return (
      this.discounts.get('email')?.reduce((a, b) => a + b?.discount, 0) ?? 0
    )
  }

  get couponDiscount() {
    return (
      this.discounts.get('coupon')?.reduce((a, b) => a + b?.discount, 0) ?? 0
    )
  }

  get loyaltyDiscount() {
    return (
      this.totalDiscount - this.newsletterDiscount - this.couponDiscount
    )
  }

  get totalDiscount() {
    return (
      Array.from(this.discounts.values())
        .flat(1)
        .reduce((a, b) => a + b?.discount, 0) ?? 0
    )
  }

  get personalPrice() {
    return this.price + this.couponDiscount
  }

  getPriceFor(eventGroup) {
    if (this.price) {
      return this.price
    }
    return eventGroup.pricePerParticipant
  }

  updateContent (value, withDiscountsUpdate = true) {
    let participantValue = Object.values(value?.participants ?? {}).find(
      p => p.data?.email === this.email
    )

    this.price = participantValue?.data?.price ?? this.price
    this.vat = participantValue?.data?.vat ?? this.vat

    this.newsletter = participantValue?.data?.newsletter ?? false

    let discounts = participantValue?.data?.discounts
    if (withDiscountsUpdate && discounts != null) {
      this.discounts.replace(discounts)
    }
  }
}
